import { useState, useEffect } from 'react'
import type { Channel } from '../types/channel'
import { fetchChannels } from '../utils'

export function useChannels() {
  const [data, setData] = useState<Channel[] | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        const channels = await fetchChannels()
        setData(channels)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [])

  return { data, isLoading, error }
}
